export const defaultDateFormat = 'DD/MM/YYYY';
export const defaultNumberFormat = '##/##/####';
export const defaultMask = '_';